import {Input} from "antd";
import React, {useState} from "react";
import debounce from 'lodash.debounce'

const DEBOUNCE_TIMEOUT = 300;

const InputDebounce = props => {
    const callApi = props.onChange;
    const [handleChange] = useState(() => debounce(callApi, DEBOUNCE_TIMEOUT));
    return <Input {...props} onChange={handleChange} />;
};

export default InputDebounce;